import {
    LIVE_OPERATOR_LIST_START,
    LIVE_OPERATOR_LIST_SUCCESS,
    LIVE_OPERATOR_LIST_ERROR
} from "Constant";

const initialState = {
    loading: false,
    liveOperatorListData: {},
};
export default function LiveOperatorListReducer(state = { ...initialState }, action) {
    switch (action.type) {
        case LIVE_OPERATOR_LIST_START:
            return {
                ...state,
                loading: true,
            };
        case LIVE_OPERATOR_LIST_SUCCESS:
            return {
                ...state,
                liveOperatorListData: action.payload,
                loading: false,
            };
        case LIVE_OPERATOR_LIST_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        default:
            return state;
    }
}

